import { Button, Divider, Header, Image } from "semantic-ui-react";
import { useState, useContext } from "react";
import { AuthContext } from "../AuthContext";
import CSRText from "./CSRText";
import AttorneyText from "./AttorneyText";

const Welcome = (props) => {
  const { loginContext } = useContext(AuthContext);

  const { isWelcome, setWelcome } = props;

  const handleDimiss = () => {
    setWelcome(false);
    localStorage.setItem("stenexusWelcome", false);
  };
  return (
    <div
      style={{
        position: "absolute",
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ position: "absolute", top: 45, left: 270 }}>
        <Image
          className="animate__animated animate__pulse animate__infinite"
          src="/images/sten-arrow-left.png"
          style={{ height: "100px", zIndex: 1 }}
        />
      </div>
      <div style={{ position: "absolute", top: 45, left: 400 }}>
        <Image
          className="animate__animated animate__pulse animate__infinite"
          src="/images/sten-arrow-left.png"
          style={{ height: "100px", zIndex: 1 }}
        />
      </div>
      <div style={{ position: "absolute", top: 45, right: 30 }}>
        <Image
          className="animate__animated animate__pulse animate__infinite"
          src="/images/sten-arrow-left.png"
          style={{ height: "100px", zIndex: 1 }}
        />
      </div>
      <div
        className="animate__animated animate__fadeIn"
        style={{
          maxWidth: "80vw",
          maxHeight: "80vh",
          backgroundColor: "#F1F1F1",
          borderRadius: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            maxWidth: "500px",
            alignItems: "center",
            overflowY: "auto",
            margin: "50px",
          }}
        >
          <Image src="./images/logo.png" style={{ width: "200px" }} />
          <Header
            style={{ textAlign: "center" }}
            content="Welcome to Stenexus"
            subheader="To begin using Stenexus,
          complete the following:"
          />
          {loginContext.role === "CSR" && <CSRText />}
          {loginContext.role === "Attorney" && <AttorneyText />}
        </div>

        <div style={{ margin: "20px" }}>
          <Button animated="fade" size="large" onClick={handleDimiss}>
            <Button.Content visible>I'm Ready</Button.Content>
            <Button.Content hidden>Let's Go!</Button.Content>
          </Button>
        </div>
      </div>
    </div>
  );
};
export default Welcome;
